import { z } from 'zod';
import { MediaType } from './constants';
import { addBreadcrumb } from './observability';

// TODO: consolidate how to determine media type with preflight head request as in the shipping claim overview
export const determineFileType = (file: File): MediaType => {
  const type = file.type.split('/')[0];
  const parsedType = z.nativeEnum(MediaType).safeParse(type);

  if (!parsedType.success) {
    // The media type is not supported -- so what type is it? The enum is pretty exhaustive.
    addBreadcrumb({
      message: `Unsupported file type: ${file.type}`,
      level: 'error',
      data: {
        fileName: file.name,
        fileType: file.type,
      },
    });
    // since only used to determine how to render the file, we can return a default type of application that isn't image or video
    return MediaType.application;
  }

  return parsedType.data;
};
